document.addEventListener("DOMContentLoaded", function(event) {

    // wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e) {
        jQuery('.nav_aera #main-menu').prepend('<li><svg id="chairnav" width="346" height="401" viewBox="0 0 346 401" xmlns="http://www.w3.org/2000/svg"><path d="m332.656 4 1.877 1.105c6.462 3.809 10.846 10.679 11.376 18.4.106 1.592.106 3.31.069 5.345-.186 9.71-5.747 24.546-8.01 33.555-8.7 34.56-18.527 75.119-21.946 123.31-2.683 29.32-9.78 49.914-21.263 61.82-11.508 11.977-18.028 17.747-19.57 17.338-4.242 2.382-8.763 4.322-13.577 5.848l21.878 61.522c.954 2.686-.955 5.544-3.7 5.544-1.538 0-2.937-.934-3.579-2.388l-27.31-61.605c-7.162 1.188-14.573 1.741-22.254 1.653l3.939 36.45c.864 2.665-1.04 5.428-3.737 5.428h-.26c-1.559 0-2.974-.961-3.605-2.443l-9.409-40.204a257.882 257.882 0 0 1-43.876-8.412L134.002 394.81c-1.018 3.664-4.24 6.19-7.899 6.19-5.364 0-9.292-5.267-7.972-10.69l31.742-130.162c-18.246-6.362-33.29-12.37-45.1-17.963-11.737-5.616-17.812-8.59-18.22-8.938-.334-.16-.695-.331-1.097-.503l-43.023 93.032c-1.05 2.272-3.26 3.72-5.678 3.72h-.18c-4.834 0-8.057-5.179-6.08-9.755 11.174-25.823 40.664-94.005 40.664-94.005-70.08-29.885-73.17-94.21-70.567-99.648.822 3.57 1.59 7.522 2.709 11.336 4.808 16.415 14.1 32.018 18.58 38.734a101.224 101.224 0 0 0 7.331 9.689 95.135 95.135 0 0 0 8.8 9.164 84.925 84.925 0 0 0 10.406 8.03 107.512 107.512 0 0 0 11.736 6.5c4.145 1.797 8.513 3.317 13.078 4.594a106.398 106.398 0 0 0 13.687 2.67c9.451 1.116 19.035 1.116 28.731 0a54.614 54.614 0 0 0 3.668-.377c1.145-.16 2.327-.348 3.547-.508 2.37-.348 4.76-.641 7.209-.885 4.808-.685 9.621-1.376 14.434-2.045a5722.03 5722.03 0 0 0 29.458-4.206 314.457 314.457 0 0 1 29.707-3.449 62.616 62.616 0 0 1 14.312.376c1.225.172 2.349.348 3.42.52 1.129.337 2.284.685 3.408 1.017 2.21.68 4.368 1.58 6.494 2.68 4.145 2.206 8.264 4.848 12.351 7.893l6.107 4.726a70.126 70.126 0 0 0 6.605 4.466c4.564 2.973 9.568 5.223 15.033 6.743 2.688.696 5.582.99 8.683.9 3.017-.26 5.953-1.143 8.8-2.68 2.682-1.614 4.967-3.598 6.844-5.98a36.841 36.841 0 0 0 4.394-7.54c2.126-5.178 3.589-10.396 4.41-15.663.891-5.278 1.474-10.468 1.707-15.553.154-2.465.324-4.975.488-7.534.085-1.271.154-2.504.25-3.68.153-1.272.28-2.51.365-3.698.25-2.465.488-4.886.737-7.263.233-2.465.488-4.886.72-7.268a844.522 844.522 0 0 1 1.84-14.282 533.896 533.896 0 0 1 4.533-27.403c1.712-8.833 3.572-17.422 5.619-25.757a698.605 698.605 0 0 1 2.936-12.11c.568-2.028 1.098-3.99 1.585-5.847a177.535 177.535 0 0 1 1.585-5.87c3.09-10.866 7.21-23.673 10.883-34.528A30.29 30.29 0 0 0 338 13.28c-.817-2.609-2.195-4.985-3.79-7.163L332.655 4zm-61.262 6.82c3.78-7.415 9.743-11.051 17.598-10.809 7.066.216 15.197.624 24.166 1.198 7.187.452 13.018 3.365 16.41 8.204 3.451 4.911 4.32 11.455 2.513 18.92-.811 3.346-3.046 10.774-5.333 18.172l-.404 1.305c-2.019 6.512-4.016 12.813-5.05 16.079l-.212.662c-4.898 15.245-9.36 31.963-13.262 49.686-4.002 17.96-7.055 37.139-9.075 56.952l-.742 7.57a266.614 266.614 0 0 0-.546 6.506l-.577 6.582c-.371 3.03-.796 5.998-1.3 8.872a61.833 61.833 0 0 1-4.006 13.292c-1.697 3.907-4.06 6.804-6.923 8.553-3.064 1.633-6.472 1.87-10.447.728-4.108-1.137-8.211-2.985-12.15-5.48-2.019-1.34-4.05-2.736-5.973-4.088l-6.027-4.745a96.398 96.398 0 0 0-6.626-4.601 36.038 36.038 0 0 0-3.599-2.28 53.679 53.679 0 0 0-3.625-1.936 48.405 48.405 0 0 0-7.978-3.305 49.877 49.877 0 0 0-4.277-1.208c-1.336-.27-2.73-.48-4.156-.662a83.546 83.546 0 0 0-10.204-.64c-2.056 0-4.087.082-6.085.242a385.013 385.013 0 0 0-30.468 3.725 6069.685 6069.685 0 0 1-29.45 4.69c-4.802.767-9.605 1.49-14.465 2.18-2.348.413-4.686.8-7.018 1.13l-7.05 1.01c-2.258.254-4.5.458-6.764.623l-3.424.265c-1.097.083-2.189.127-3.345.127a113.2 113.2 0 0 1-6.705 0 90.176 90.176 0 0 1-6.498-.502 82.77 82.77 0 0 1-12.812-2.251 81.578 81.578 0 0 1-11.794-3.835 100.658 100.658 0 0 1-10.988-5.59 82.775 82.775 0 0 1-9.658-7.09 80.137 80.137 0 0 1-8.385-8.237 80.326 80.326 0 0 1-7.15-8.79c-8.01-11.89-13.82-23.968-17.763-36.984-1.007-3.018-1.781-6.207-2.534-9.292L7 124.825c4.134-.15 13.416 2.075 18.218 3.228 11.82 2.825 30.908 11.449 56.706 25.623 31.73 18.065 56.457 25.282 73.493 21.464 17.079-3.835 32.472-16.592 45.723-37.867 9.626-14.594 20.513-32.924 32.366-54.492 8.597-15.681 16.49-30.402 23.455-43.76 1.064-2.037 4.861-9.45 8.936-17.426l.445-.872.224-.437.671-1.315.448-.877.447-.876c1.117-2.188 2.22-4.353 3.262-6.398z" fill="" fill-rule=""/></svg></li>');

        let mm = gsap.matchMedia();

        mm.add("(max-width: 767px)", () => {
            const tlHeroTwo = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".textBlock",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeroTwo.from("#two", { x: 100 });

            const tlHadlineReferenzen = gsap.timeline({
                defaults: { duration: .1 },
                scrollTrigger: {
                    trigger: ".headline.referenzen",
                    scrub: true,
                    immediateRender: false,
                    toggleActions: "restart none none reverse",
                    markers: false
                }
            });

            tlHadlineReferenzen.from(".headline.referenzen", { x: 500 });
            // timeline for wir bieten first line
            const tlHeadRefOne = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-one",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefOne.from(".wir-bieten-one", { x: -100 });


            // timeline for wir bieten second line
            const tlHeadRefTwo = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-two",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefTwo.from(".wir-bieten-two", { x: 50 });


            // timeline for wir bieten third line
            const tlHeadRefThree = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-three",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefThree.from(".wir-bieten-three", { x: -100 });


            // timeline for wir bieten second line
            const tlHeadRefFour = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-four",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefFour.from(".wir-bieten-four", { x: 50 });

            // timeline for the service
            const tlService = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".headline-service",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlService.from(".headline-service", { x: -100, opacity: 1 });

        });

        mm.add("(min-width: 768px)", () => {

            const chair = document.getElementById('chairnav');

            gsap.to(chair, {
                fill: '#095256',
                duration: 0.1,
                ease: "back.out(2)",
                scrollTrigger: {
                    trigger: '#projekte',
                    endtrigger: '#wir-bieten',
                    invalidateOnRefresh: false,
                    start: "-=380px",
                    end: "bottom 50%+=100px",
                    toggleActions: "play reverse play reverse",
                    scrub: false,
                    duration: .1,
                    ease: Power1.easeInOut,
                    markers: false
                }
            });

            const nav = gsap.utils.toArray('#main-menu .nav-link');

            nav.forEach(nav => {
                gsap.to(nav, {
                    color: '#095256',
                    duration: 0.1,
                    ease: "back.out(2)",
                    scrollTrigger: {
                        trigger: '#projekte',
                        endtrigger: '#wir-bieten',
                        invalidateOnRefresh: false,
                        start: "-=580px",
                        //start: () => "-=500px",
                        end: () => "+=1300px",
                        toggleActions: "play reverse play reverse",
                        scrub: false,
                        duration: .1,
                        stagger: .1,
                        markers: false
                    }
                })
            });

            nav.forEach(nav => {
                gsap.to(nav, {
                    color: '#095256',
                    duration: 0.1,
                    ease: "back.out(2)",
                    scrollTrigger: {
                        trigger: '#ueber-uns',
                        endtrigger: '#wrapper-footer',
                        invalidateOnRefresh: false,
                        start: "-=580px",
                        // end: "+480px",
                        //start: () => "-=500px",
                        end: () => "bottom 50%",
                        toggleActions: "play reverse play reverse",
                        scrub: false,
                        duration: .1,
                        stagger: .1,
                        markers: false
                    }
                })
            });

            gsap.to(chair, {
                fill: '#095256',
                duration: 0.1,
                ease: "back.out(2)",
                scrollTrigger: {
                    trigger: '#ueber-uns',
                    endtrigger: '#wrapper-footer',
                    invalidateOnRefresh: false,
                    start: "-=400px",
                    toggleActions: "play reverse play reverse",
                    scrub: false,
                    duration: .1,
                    ease: Power1.easeInOut,
                    markers: false
                }
            });

            ScrollTrigger.create({
                trigger: "#intro",
                start: "top top", //start when the top of the trigger element hits the top of the window
                endTrigger: "#wrapper-footer",
                end: "top bottom",
                pin: ".nav_aera #main-menu",
                markers: false
            });

            // timeline for the Hero first line
            const tlHeroOne = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".textBlock",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            // Add animations to the timeline
            tlHeroOne.from("#one", { x: 50, opacity: 1 });

            // timeline for the Hero second line
            const tlHeroTwo = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".textBlock",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeroTwo.from("#two", { x: -1000 });

            // timeline for the Hero third line
            const tlHeroThree = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".textBlock",
                    scrub: true,
                    immediateRender: false,
                    toggleActions: "restart none none reverse",
                }
            });

            tlHeroThree.from("#three", { x: -50, opacity: 1 });

            // timeline for the Referenzen Headline
            const tlHadlineReferenzen = gsap.timeline({
                defaults: { duration: .1 },
                scrollTrigger: {
                    trigger: ".headline.referenzen",
                    scrub: true,
                    immediateRender: false,
                    toggleActions: "restart none none reverse",
                    markers: false
                }
            });

            tlHadlineReferenzen.from(".headline.referenzen", { x: 800 });

            // timeline for wir bieten first line
            const tlHeadRefOne = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-one",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefOne.from(".wir-bieten-one", { x: -100 });


            // timeline for wir bieten second line
            const tlHeadRefTwo = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-two",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefTwo.from(".wir-bieten-two", { x: 50 });


            // timeline for wir bieten third line
            const tlHeadRefThree = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-three",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefThree.from(".wir-bieten-three", { x: -100 });


            // timeline for wir bieten second line
            const tlHeadRefFour = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".wir-bieten-four",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlHeadRefFour.from(".wir-bieten-four", { x: 50 });

            // timeline for the service
            const tlService = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".headline-service",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlService.from(".headline-service", { x: -1000, opacity: 0 });


            // timeline for über uns first line
            const tlUeberunsOne = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".ueberuns-headline-one",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlUeberunsOne.from(".ueberuns-headline-one", { x: -100 });


            // timeline for wir bieten second line
            const tlUeberunsTwo = gsap.timeline({
                defaults: { duration: 1 },
                scrollTrigger: {
                    trigger: ".ueberuns-headline-two",
                    scrub: true,
                    toggleActions: "restart none none reverse",
                    immediateRender: false,
                    markers: false
                }
            });

            tlUeberunsTwo.from(".ueberuns-headline-two", { x: 50 });

        });

        jQuery('.nav-item').attr('data-bs-dismiss', 'offcanvas');
        jQuery('.home .swiperPortfolio .btn').click(function() {
            jQuery('.modal-body .carousel-item:first-child').addClass('active');
            jQuery('.home .modal-body .carousel-indicators button:first-child').addClass('active');
        })
        jQuery('.home .modal').on('hide.bs.modal', function() {
            jQuery('.home .modal-body .carousel-item').removeClass('active');
            jQuery('.home .modal-body .carousel-indicators button').removeClass('active');
        });


    }, false);

});